<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  expanded: { type: Boolean, default: true },
});
const emit = defineEmits(['toggle']);
const { t } = useI18n({
  useScope: 'local',
  messages: {
    en: { hide: 'Hide navigation', show: 'Show navigation' },
    ru: { hide: 'Скрыть навигацию', show: 'Показать навигацию' },
  },
});
const label = computed(() => (props.expanded ? t('hide') : t('show')));
</script>

<template>
  <Button
    :id="expanded ? 'hide-navigation' : 'show-navigation'"
    icon="i-lucide-menu"
    variant="ghost"
    color="slate"
    :aria-label="label"
    :title="label"
    :aria-expanded="expanded"
    aria-controls="main-navigation"
    @click="emit('toggle')"
  />
</template>
